
import request from '@/utils/ajax';

//钱包信息接口
export function queryWalletnfo(data) {
  return request({
    url: '/pms/crm/systemWallet',
    method: 'get',
  });
}

//编辑手续费
export function updatePayFee(data) {
  return request({
    url: '/pms/crm/updatePayFee',
    method: 'put',
    data,
  });
}


//客户列表
export function queryCust(data) {
  return request({
    url: '/pms/crm/pageCust',
    method: 'get',
    params: data,
  });
}

// 客户详情
export function queryCustDetail(data) {
  return request({
    url: '/pms/crm/custDetail',
    method: 'get',
    params: data,
  });
}

// 审核客户
export function auditCust(data) {
  return request({
    url: '/pms/crm/auditCust',
    method: 'put',
    data,
  });
}

// 资产流水列表
export function queryPageWalletTrans(data) {
  return request({
    url: '/pms/crm/pageWalletTrans',
    method: 'get',
    params: data,
  });
}

// 流水审核
export function auditWalletTrans(data) {
  return request({
    url: '/pms/crm/auditWalletTrans',
    method: 'put',
    data,
  });
}

// 流水支付
export function payWalletTrans(data) {
  return request({
    url: '/pms/crm/payWalletTrans',
    method: 'put',
    data,
  });
}



// 手动回调商户?
export function notifyMerchant(data) {
  return request({
    url: '/pms/crm/notifyMerchant',
    method: 'post',
    data,
  });
}


export function confirmApiTrans(data) {
  return request({
    url: '/pms/crm/confirmApiTrans',
    method: 'post',
    data,
  });
}



// 手动归集
export function collectMerWallet(data) {
  return request({
    url: '/pms/crm/collectMerWallet/'+data.orderSerialNo,
    method: 'put',
  });
}









